<template>
  <div :class="[$style.watermark, $style[ribbonPosition]]">
    <a href="https://onvocado.com/?utm_source=link&utm_medium=onvocado_popup" target="_blank">
      <div :class="$style.watermarkInner">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 300" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:src="'./assets/logo.svg'" v-bind:alt="'Onvocado Logo'" v-bind:role="'presentation'" v-bind:focusable="'false'"><path fill="#f8f9e8" d="M194.58 167.48a93.225 93.225 0 00-3.96-9.82L137.88 27.12C132.52 11.34 117.58 0 100 0S68.98 10.24 63 24.8h-.02L7.86 161.08l-.36.88C2.66 173.68 0 186.52 0 200c0 55.22 44.78 100 100 100s100-44.78 100-100c0-11.38-1.9-22.32-5.42-32.52zM100 260c-33.14 0-60-26.86-60-60s26.86-60 60-60 60 26.86 60 60-26.86 60-60 60z"/></svg>
        <span :class="[$style.poweredBy]">Powered by onvocado</span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Watermark',
  props: {
    isRibbon: {
      type: Boolean,
      default: false,
    },
    ribbonPosition: {
      type: String,
      required: false,
      default: 'bottomRight',
    },
  },
}
</script>

<style lang="scss" module>
@import '@shared/assets/sass/design/_breakpoints';

.watermark.watermark {
  position: absolute;
  bottom: 20px;
  color: #f8f8f8;
  font-size: .85em;
  z-index: 20;

  a, a:visited, a:hover, a:active {
    color: inherit;
  }

  @media screen and (max-width: $bp-tablet) {
    bottom: 0;
  }
}

.poweredBy {
  margin-top: 5px;
  text-transform: uppercase;

  @media screen and (max-width: $bp-tablet) {
    margin-top: 2px;
  }
}

.watermarkInner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  svg {
    width: 18px;

    @media screen and (max-width: $bp-tablet) {
       width: 14px;
    }
  }

  @media screen and (max-width: $bp-tablet) {
    padding: 7.5px;
    border-radius: 7.5px;
    border-bottom-right-radius: 0;
    background-color: #0f2815;
  }
}

.bottomRight {
  left: 20px;
  right: auto;

  @media screen and (max-width: $bp-tablet) {
    left: 0;
  }
}

.bottomLeft {
  left: auto;
  right: 20px;

  @media screen and (max-width: $bp-tablet) {
    right: 0;
  }
}
</style>